export default __webpack_public_path__ + "resources/icons/n240-f467.png";